<template>
<div class="seller" ref="seller">
	<div class="serller-content">
		<div class="overview">
			<h1 class="title">{{seller.name}}</h1>
			<div class="desc">
				<star :size="36" :score="seller.score"></star>
				<span class="text">({{seller.ratingCount}})</span>
				<span class="text">月售{{ seller.sellCount }}单</span>
			</div>
			<ul class="remark">
				<li class="block">
					<h2>起送价</h2>
					<div class="content">
						<span class="stress">{{seller.minPrice}}</span>元
					</div>
				</li>
				<li class="block">
					<h2>商家配送</h2>
					<div class="content">
						<span class="stress">{{seller.deliveryPrice}}</span>元
					</div>
				</li>
				<li class="block">
					<h2>平均配送时间</h2>
					<div class="content">
						<span class="stress">{{seller.deliveryTime}}</span>分钟
					</div>
				</li>
			</ul>
			<div class="favorite" @click="toggleFavorite">
				<span class="icon-favorite" :class="{'active': favorite}"></span>
				<span class="text">{{favoriteText}}</span>
			</div>
		</div>
		<split></split>
		<div class="bulletin">
			<h1 class="title">公告与活动</h1>
			<div class="content-wrapper">
				<p class="content">{{seller.bulletin}}</p>
			</div>
			<ul v-if="seller.supports" class="supports">
				<li class="support-item border-1px" v-for="(item, index) in seller.supports">
					<span class="icon" :class="classMap[seller.supports[index].type]"></span>
					<span class="text">{{seller.supports[index].description}}</span>
				</li>
			</ul>
		</div>
		<split></split>
		<div class="pics">
			<h1 class="title">商家实景</h1>
			<div class="pic-wrapper" ref="picsWrapper">
				<ul class="pic-list" ref="picList">
					<li class="pic-item" v-for="pic in seller.pics">
						<img :src="pic" width="120" height="90">
					</li>
				</ul>
			</div>
		</div>
		<split></split>
		<div class="info">
			<h1 class="title">商家信息</h1>
			<ul>
				<li class="info-item" v-for="info in seller.infos">{{info}}</li>
			</ul>
		</div>
	</div>
</div>
</template>

<script>
import star from '@/components/star/star';
import split from '@/components/split/split';
import BScroll from 'better-scroll';
import axios from 'axios';
import {urlParse} from '@/common/js/util';
import {saveToLocal, loadFromLocal} from '@/common/js/store';

export default {
	props: {
		seller: {
			type: Object
		}
	},
	data() {
		return {
            seller0: {
                id: (() => {
                  let queryParam = urlParse();
                  return queryParam.id;
                })()
            },
            favorite: false
		}
	},
	computed: {
		favoriteText() {
			return this.favorite ? '已收藏' : '收藏';
		}
	},
	created() {
		this._initSeller(),
        this._initFavorite(),
		this.classMap = ['decrease', 'discount', 'special', 'invoice', 'guarantee'];
	},
	methods: {
        _initFavorite() {
            this.favorite = loadFromLocal(this.seller0.id, 'favorite', false);
        },
		_initSeller() {
			axios.get('static/data.json?id=' + this.seller.id).then((res) => {
                // 相当于 extend方法 扩展  es6语法   vue推荐的给对象扩展属性方法
                this.seller0 = Object.assign({}, this.seller0, res.data.seller);
				this.$nextTick(() => {
					if(!this.sellerScroll) {
			    		// 页面整体滚动
				        this.sellerScroll = new BScroll(this.$refs.seller, {
				            click: true
				        });
				        this._initPicScroll();
			    	} else {
			    		this.sellerScroll.refresh();
			    	}
				});
			})
		},
		_initPicScroll() {
	    	if(this.pcisScroll) {
	    		return
	    	}
	    	const PIC_WIDTH = 120;
	    	const MARGIN = 6;
	    	let picLen = this.seller0.pics.length;
	    	this.$refs.picList.style.width = PIC_WIDTH * picLen + MARGIN * (picLen - 1) + 'px'
			this.picsScroll = new BScroll(this.$refs.picsWrapper, {
				scrollX: true,
				eventPassthrough: 'vertical'
			})
	    },
	    toggleFavorite() {
	    	if (!event._constructed) {
                return;
            }
	    	this.favorite = !this.favorite;
            saveToLocal(this.seller0.id, 'favorite', this.favorite);
	    }
	},
	components: {
		star,
		split
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style rel="stylesheet/scss" lang="scss" scoped>
@import "../../common/scss/mixins";
.seller {
    position: absolute;
    top: 174px;
    bottom: 0;
    left: 0;
    width: 100%;
    overflow: hidden;
    .overview {
        position: relative;
        padding: 18px;
        .title {
            margin-bottom: 8px;
            line-height: 14px;
            color: rgb(7, 17, 27);
            font-size: 14px;
        }
        .desc {
            padding-bottom: 18px;
            @include border-1px(rgba(7, 17, 27, .1));
            font-size: 0;
            .star {
                display: inline-block;
                vertical-align: top;
                margin-right: 8px;
            }
            .text {
                display: inline-block;
                vertical-align: top;
                margin-right: 12px;
                line-height: 18px;
                font-size: 10px;
                color: rgb(77, 85, 93);
            }
        }
        .remark {
            display: flex;
            padding-top: 18px;
            .block {
                flex: 1;
                text-align: center;
                border-right: 1px solid rgba(7, 17, 27, .1);
                &:last-child {
                    border: none;
                }
                h2 {
                    margin-bottom: 4px;
                    line-height: 10px;
                    font-size: 10px;
                    color: rgb(147, 153, 159);
                }
                .content {
                    line-height: 24px;
                    font-size: 10px;
                    color: rgb(7, 17, 27);
                    .stress {
                        font-size: 24px;
                    }
                }
            }
        }
        .favorite {
            position: absolute;
            right: 11px;
            top: 18px;
            width: 50px;
            text-align: center;
            .icon-favorite {
                display: block;
                margin-bottom: 4px;
                line-height: 24px;
                font-size: 24px;
                color: #d4d6d9;
                &.active {
                    color: rgb(240, 20, 20);
                }
            }
            .text {
                line-height: 10px;
                font-size: 10px;
                color: rgb(77, 85, 93);
            }
        }
    }
    .bulletin {
        padding: 18px 18px 0 18px;
        .title {
            margin-bottom: 8px;
            line-height: 14px;
            color: rgb(7, 17, 27);
            font-size: 14px;
        }
        .content-wrapper {
            padding: 0 12px 16px 12px;
            @include border-1px(rgba(7, 17, 27, .1));
            .content {
                line-height: 24px;
                font-size: 12px;
                color: rgb(240, 20, 20);
            }
        }
        .supports {
            .support-item {
                padding: 16px 12px;
                font-size: 0;
                @include border-1px(rgba(7, 17, 27, .1));
                &:last-child {
                    @include border-none();
                }
                .icon {
                    display: inline-block;
                    vertical-align: top;
                    width: 16px;
                    height: 16px;
                    margin-right: 6px;
                    background-size: 16px 16px;
                    background-repeat: no-repeat;
                    &.decrease {
                        @include bg-image('decrease_4');
                    }
                    &.discount {
                        @include bg-image('discount_4');
                    }
                    &.guarantee {
                        @include bg-image('guarantee_4');
                    }
                    &.invoice {
                        @include bg-image('invoice_4');
                    }
                    &.special {
                        @include bg-image('special_4');
                    }
                }
                .text {
                    line-height: 16px;
                    font-size: 12px;
                    color: rgb(7, 17, 27);
                }
            }
        }
    }
    .pics {
        padding: 18px;
        .title {
            margin-bottom: 12px;
            line-height: 14px;
            color: rgb(7, 17, 27);
            font-size: 14px;
        }
        .pic-wrapper {
            width: 100%;
            overflow: hidden;
            white-space: nowrap;
            .pic-list {
                font-size: 0;
                .pic-item {
                    display: inline-block;
                    margin-right: 6px;
                    width: 120px;
                    height: 90px;
                    &:last-child {
                        margin: 0;
                    }
                }
            }
        }
    }
    .info {
        padding: 18px 18px 0 18px;
        color: rgb(7, 17, 27);
        .title {
            padding-bottom: 8px;
            line-height: 14px;
            font-size: 14px;
            @include border-1px(rgba(7, 17, 27, .1));
        }
        .info-item {
            padding: 16px 12px;
            line-height: 16px;
            @include border-1px(rgba(7, 17, 27, .1));
            font-size: 12px;
            &:last-child {
                @include border-none();
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/seller/seller.vue